"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixEnglishQuotes = void 0;
function fixEnglishQuotes(text) {
    return (text
        // replaces english quote marks with their persian equivalent
        .replace(/([“"'`]+)(.+?)(\1)/g, "«$2»"));
}
exports.fixEnglishQuotes = fixEnglishQuotes;
